import { type FC, type ReactNode } from 'react';
import { PublicTopBar } from '@/acc-ui/components/PublicTopBar';

/**
 * MarketingShell — public (unauthenticated) page frame for the Product /
 * How it Works / Resources pages. Shares the login top bar + footer.
 */

export const MarketingShell: FC<{ children: ReactNode }> = ({ children }) => (
  <div
    className="min-h-[100dvh] flex flex-col bg-background"
    style={{ paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)' }}
  >
    <PublicTopBar />
    <main className="flex-1">
      <div className="max-w-5xl mx-auto w-full px-6 py-12 lg:py-16">{children}</div>
    </main>
    <footer className="shrink-0 border-t border-outline-variant">
      <div className="max-w-6xl mx-auto w-full px-6 py-4 text-center text-micro text-on-surface-variant">
        © 2026 Applied Cloud Computing Private Limited
      </div>
    </footer>
  </div>
);

/** Page header used across the marketing pages. */
export const MarketingHeader: FC<{ eyebrow: string; title: string; lead?: string }> = ({
  eyebrow,
  title,
  lead,
}) => (
  <header className="max-w-2xl">
    <span className="text-micro font-semibold uppercase tracking-[0.1em] text-primary">{eyebrow}</span>
    <h1 className="mt-3 font-display font-black tracking-tight text-on-surface text-[clamp(2rem,4vw,3rem)] leading-[1.08]">
      {title}
    </h1>
    {lead && <p className="mt-4 text-body text-on-surface-variant leading-relaxed">{lead}</p>}
  </header>
);

export default MarketingShell;
